import {until} from 'lit-html/directives/until';
import '../dropdown';

export default (ctx, html) => html`
<div>
  <ems-dropdown class="full-width w-100" ?disabled="${ctx.disabled}">
    <button slot="dropdown-toggle" class="border-rounded btn btn-block border form-control text-left d-flex justify-content-between" ?disabled="${ctx.disabled}">
      <slot>
        ${ctx.single ? html`
          <span class="mr-5">${ctx.teacher? html`${until(ctx.__('<tt-L7Jyzezd>', 'Select a Teacher'))}`: html`${until(ctx.__('<tt-/CdjsldI>', 'Select a Student'))}`}</span>
        ` : html`
          <span class="mr-5">${ctx.teacher? html`${until(ctx.__('<tt-Cd8Ttq74>', 'Select Teachers'))}`: html`${until(ctx.__('<tt-VyiDKeNU>', 'Select Students'))}`}</span>
        `}
      </slot>
      <span class="ai ai-chevron-down"></span>
    </button>
    <div slot="dropdown-menu" class="dropdown-menu m-0 w-100" @click="${(e) => !ctx.single && e.stopPropagation()}">
      <div class="form-group p-3">
        <label for="teacher-student-search">
          ${ctx.teacher? html`${until(ctx.__('<tt-H4CL56EW>', 'Teacher Search'))}`: html`${until(ctx.__('<tt-dzeWiwXc>', 'Student Search'))}`}
        </label>
        <input id="teacher-student-search" class="form-control form-control-sm" @input="${ctx.searchInputHandler}" placeholder="${until(ctx.i18n.__('<tt-Xy398ZDm>', 'Search...'))}" @click="${(e) => e.stopPropagation()}">
        <small class="form-text text-muted">${until(ctx.__('<tt-gDRX2MeV>', 'Search by name'))}</small>
      </div>
      <div class="dropdown-divider"></div>
      <div class="result-container">
      ${ctx.results.length? html`
        ${ctx.results.map((item) => html`
          <button class="btn dropdown-item ${ctx.selected.indexOf(item.id) > -1? 'disabled': ''}" @click="${(e) => ctx.selectHandler(e, item)}">${item.name}</button>
        `)}
      `: html`
        <p class="p-3">${until(ctx.__('<tt-CxRrm0kV>', 'No results found...'))}</p>
      `}
      </div>
    </div>
  </ems-dropdown>
</div>
`;
